export default __webpack_public_path__ + "static/media/logo.ce71394a.png";